import React from 'react'
import { Route, Switch} from 'react-router-dom'
// import {
//     PrivacyPolicy,
//     TermsUpdate,
//     Commitment,
//     EventDes,
//     DmEarn,
//     Invite,
//     InviteInfo,
//     GetCash,
//     PrivacyText,
//     Help
// } from '@/views'
import PrivacyPolicy from '@/views/privacyPolicy'
import TermsUpdate from '@/views/termsUpdate'
import Commitment from '@/views/commitment'
import EventDes from '@/views/eventdes'
import DmEarn from '@/views/dmearn'
// import DayEarn from '@/views/dayearn'
// import MonthEarn from '@/views/monthearn'
import Invite from '@/views/invite'
import InviteInfo from '@/views/inviteinfo'
import InviteVideo from '@/views/invite/video'
import GetCash from '@/views/getcash'
import PrivacyText from '@/views/privacytext'
import RecordText from '@/views/recordtext'
import Help from '@/views/help'
import InformationSharing from '@/views/informationSharing'
import ServiceTerm from '@/views/serviceterm'
import WithdrawalRules from '@/views/withdrawalrules'
import HelpDetails from '@/views/helpdetails'
import Setting from '@/views/setting'
import PhoneVerify from '@/views/phoneverify'
import NewUser from '@/views/newuser'
import OldUser from '@/views/olduser'
import HhForDiDi from '@/views/hhchuxing/fordidi'
import SLine from '@/views/hhchuxing/fordidi/sline'
import PPrivacy from '@/views/hhchuxing/fordidi/pprivacy'
import Call from '@/views/hhchuxing/fordidi/call'
import SdkState from '@/views/sdkstate'
import FleetLeader  from '@/views/fleetleader'
import FleetManage from '@/views/fleetmanage'
import MyFleet from '@/views/myfleet'
import FleetQRcode from '@/views/fleetqrcode'
import JoinFleet from '@/views/joinfleet'
import JoinFleetVerify from '@/views/joinfleetverify'
import JoinFleetOk from '@/views/joinfleetok' 
import FleetAwardPage from '@/views/fleetawardpage'
import Carefree from '@/views/carefree'
// 乘客端协议新增@zhz
// 1.(2021.11.1）录音录像信息收集及隐私保护协议
import PassgerInformation from '@/views/passgerInformation'
// 2.（2021.11.1）隐私政策
import PassgerPrivacy from '@/views/passgerPrivacy'
// 3.（2021.11.1)网约车乘客服务协议
import PassgerServe from '@/views/passgerServe'
//防疫检测
import Gvc from '@/views/gvc'
import GvcReport from '@/views/gvc/report'
import GvcProve from '@/views/gvc/prove'
import GvcPlace from '@/views/gvc/place'
import DriverRules from '@/views/driverRules'
import Income from '@/views/income'
import ReOrderDes from '@/views/doc/ReOrderDes'
import SaveImg  from '@/views/saveImg'
import RushBill from '@/views/rushBill'
import ProxyDriving from '@/views/proxyDriving/index.jsx'
import FreeCommissionCard from '@/views/freeCommissionCard'
import FreeCommissionCardDetail from '@/views/freeCommissionCard/detail'
import FreeCommissionCardMy from '@/views/freeCommissionCard/my'
import YhxyContent from '@/views/doc/yhxyContent'
import YszcContent from '@/views/doc/yszcContent'
import YszczyContent from '@/views/doc/yszczyContent'
import GeneralTermContent from '@/views/doc/generalTermContent'
import PrivacyPolicyContent from '@/views/doc/privacyPolicyContent'
import VoicePhotoPrivacyContent from '@/views/doc/voicePhotoPrivacyContent'
import OfflineOrderList from '@/views/offlineOrder/index.jsx'
import CreateOrder from '@/views/offlineOrder/create.jsx'
import AirportTransferList from '@/views/airportTransfer/index.jsx'
import Login from '@/views/login'
import Home from '@/views/home'
import Wallet from '@/views/wallet'
import MessageCenter from '@/views/messageCenter'
import ChatPage from '@/views/messageCenter/chat'

function Router() {
    return (
        // <Suspense fallback={''}>
            <Switch>
                <Route path="/privacy" exact render={(props) => <PrivacyPolicy {...props} />} />
                <Route path="/termsupdate" exact render={(props) => <TermsUpdate {...props} />} />
                <Route path="/commitment" exact render={() => <Commitment />} />
                <Route path="/eventdes" exact render={() => <EventDes />} />
                <Route path="/dmearn" render={() => <DmEarn />} />
                <Route path="/invite" exact render={(props) => <Invite {...props} />} />
                <Route path="/inviteinfo/:p/:money" exact render={(props) => <InviteInfo {...props} />} />
                <Route path="/inviteVideo/:videoUrl" exact render={(props) => <InviteVideo {...props} />} />
                <Route path="/getcash" exact render={(props) => <GetCash {...props} />} />
                <Route path="/privacytext" exact render={() => <PrivacyText />} />
                <Route path="/recordtext" exact render={() => <RecordText />} />
                <Route path="/help" exact render={(props) => <Help {...props} />} />
                <Route path="/informationSharing" exact render={(props) => <InformationSharing {...props} />} />
                <Route path="/service" exact render={() => <ServiceTerm />} />
                <Route path="/withdrawalrules" exact render={() => <WithdrawalRules />} />
                <Route path="/helpdetails/:id" exact render={(props) => <HelpDetails {...props} />} />
                <Route path="/setting" exact render={(props) => <Setting {...props}/>} />
                <Route path="/phoneverify/:cxname/:phone/:drivername/:cityid" exact render={(props) => <PhoneVerify {...props}/>} />
                <Route path="/newuser/:phone/:token" exact render={(props) => <NewUser {...props}/>} />
                <Route path="/olduser/:phone/:token" exact render={(props) => <OldUser {...props}/>} />
                <Route path="/hhfordidi" exact render={(props) => <HhForDiDi {...props} />} />
                <Route path="/hhfordidi/:tag" render={(props) => <HhForDiDi {...props} />} />
                <Route path="/sline" exact render={(props) => <SLine {...props} />} />
                <Route path="/pprivacy" exact render={(props) => <PPrivacy {...props} />} />
                <Route path="/call" exact render={(props) => <Call {...props} />} />
                <Route path="/sdkstate" exact render={() => <SdkState />} />
                <Route path="/fleetleader" exact render={() => <FleetLeader />} />
                <Route path="/fleetmanage" exact render={() => <FleetManage />} />
                <Route path="/myfleet" exact render={() => <MyFleet />} />
                <Route path="/fleetqrcode" exact render={() => <FleetQRcode />} />
                <Route path="/joinfleet" exact render={(props) => <JoinFleet {...props} />} />
                <Route path="/joinfleetverify/:phone" exact render={(props) => <JoinFleetVerify {...props} />} />
                <Route path="/joinfleetok/:phone/:type" exact render={(props) => <JoinFleetOk {...props} />} />
                <Route path="/fleetawardp" exact render={() => <FleetAwardPage />} />
                <Route path="/carefree" exact render={() => <Carefree />} />
                <Route path="/passgerInformation" exact render={() => <PassgerInformation />} />
                <Route path="/passgerPrivacy" exact render={() => <PassgerPrivacy />} />
                <Route path="/passgerServe" exact render={() => <PassgerServe />} />
                <Route path="/gvc" exact render={(props) => <Gvc  {...props}/>} />
                <Route path="/gvc/report" exact render={(props) => <GvcReport  {...props}/>} />
                <Route path="/gvc/prove" exact render={(props) => <GvcProve  {...props}/>} />
                <Route path="/gvc/place" exact render={(props) => <GvcPlace  {...props}/>} />
                <Route path="/driverRules" exact render={(props) => <DriverRules  {...props}/>} />
                <Route path="/income" exact render={(props) => <Income  {...props}/>} />
                <Route path="/reOrderDes" exact render={(props) => <ReOrderDes  {...props}/>} />
                <Route path="/saveImg" exact render={(props) => <SaveImg  {...props}/>} />
                <Route path="/rushBill" exact render={(props) => <RushBill  {...props}/>} />
                <Route path="/proxyDriving" exact render={(props) => <ProxyDriving  {...props}/>} />
                <Route path="/freeCommissionCard" render={(props) => <FreeCommissionCard {...props} />} />
                <Route path="/freeCommissionCardDetail" render={(props) => <FreeCommissionCardDetail {...props} />} />
                <Route path="/freeCommissionCardMy" render={(props) => <FreeCommissionCardMy {...props} />}/>
                {/* <Route path="/yhxyContent/:tag" render={(props) => <YhxyContent {...props} />}/> */}
                {/* <Route path="/yszcContent/:tag" render={(props) => <YszcContent {...props} />}/> */}
                {/* <Route path="/yszczyContent/:tag" render={(props) => <YszczyContent {...props} />}/> */}
                <Route path="/yhxyContent/:tag" render={(props) => <GeneralTermContent {...props} />}/>
                <Route path="/yszcContent/:tag" render={(props) => <PrivacyPolicyContent {...props} />}/>
                <Route path="/yszczyContent/:tag" render={(props) => <VoicePhotoPrivacyContent {...props} />}/>
                {/* <Route path="/yhxyContent" exact render={(props) => <YhxyContent {...props} />}/> */}
                {/* <Route path="/yszcContent" exact render={(props) => <YszcContent {...props} />}/> */}
                {/* <Route path="/yszczyContent" exact render={(props) => <YszczyContent {...props} />}/> */}
                <Route path="/yhxyContent" exact render={(props) => <GeneralTermContent {...props} />}/>
                <Route path="/yszcContent" exact render={(props) => <PrivacyPolicyContent {...props} />}/>
                <Route path="/yszczyContent" exact render={(props) => <VoicePhotoPrivacyContent {...props} />}/>
                <Route path="/offlineOrderList" render={(props) => <OfflineOrderList {...props} />}/>
                <Route path="/offlineOrder/create" render={(props) => <CreateOrder {...props} />}/>
                <Route path="/airportTransfer/list" render={(props) => <AirportTransferList {...props} />}/>
                <Route path="/login" exact render={(props) => <Login {...props} />} />
                <Route path="/wallet" exact render={(props) => <Wallet {...props} />} />
                <Route path="/home" exact render={(props) => <Home {...props} />} />
                <Route path="/" exact render={(props) => <Home {...props} />} />
                <Route path="/messageCenter" exact render={(props) => <MessageCenter {...props} />} />
                <Route path="/messageCenter/chat/:orderId" exact render={(props) => <ChatPage {...props} />} />
            </Switch>
        // </Suspense>
    )
}
export default Router
